import type { RouteLocationNormalizedLoaded } from 'vue-router';

// v2 serves the same /open/:businessEntityId/:orderId deep link; every other v1 route lands on the v2 start page.
export function getV2Url(
  baseUrl: string,
  route: Pick<RouteLocationNormalizedLoaded, 'name' | 'params'>
): string {
  const base = baseUrl.replace(/\/+$/, '');
  const { businessEntityId, orderId } = route.params;

  if (route.name === 'DeepLinkOpen' && businessEntityId && orderId) {
    return `${base}/open/${encodeURIComponent(String(businessEntityId))}/${encodeURIComponent(String(orderId))}`;
  }
  return `${base}/`;
}

export function getV2Host(baseUrl: string): string {
  try {
    return new URL(baseUrl).host;
  } catch {
    return baseUrl;
  }
}
